import React, { useState } from 'react';
import { Mail, MapPin, Phone, Send } from 'lucide-react';
import { Button } from '../components/ui/button';
import { api } from '../services/api';

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', phone: '', message: '' });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await api.createContactMessage({
        name: form.name,
        phone: form.phone,
        message: form.message,
      });
      setSent(true);
      setTimeout(() => setSent(false), 3000);
      setForm({ name: '', phone: '', message: '' });
    } catch (e2) {
      setError(e2?.message || 'ثبت پیام ناموفق بود.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="bg-white" dir="rtl">
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-blue-50 to-white" />
        <div className="relative pp-container py-12">
          <div className="max-w-2xl">
            <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900">تماس با ما</h1>
            <p className="text-sm sm:text-base text-gray-600 mt-3 leading-7">
              برای مشاوره انتخاب کالا، استعلام قیمت و تامین تجهیزات صنعتی، با ما در ارتباط باشید.
            </p>
          </div>
        </div>
      </section>

      <section className="pp-container py-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5">
            <div className="bg-gray-50 border border-gray-200 rounded-3xl p-6">
              <h2 className="text-lg font-extrabold text-gray-900">راه‌های ارتباطی</h2>
              <div className="mt-5 space-y-4 text-sm">
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-[#005bbb]" />
                  <span className="text-gray-700">021-xxxxxxx</span>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-[#005bbb]" />
                  <span className="text-gray-700">info@parspiping.com</span>
                </div>
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-[#005bbb] mt-0.5" />
                  <span className="text-gray-700 leading-6">
                    تهران، محل قانونی شرکت
                  </span>
                </div>
              </div>

              <div className="mt-6 rounded-2xl bg-white border border-gray-200 p-4 text-xs text-gray-600 leading-6">
                ساعت پاسخگویی: شنبه تا چهارشنبه 9 تا 17 — پنجشنبه 9 تا 13
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="bg-white border border-gray-200 rounded-3xl p-6 shadow-sm">
              <h2 className="text-lg font-extrabold text-gray-900">ارسال پیام</h2>
              <p className="text-sm text-gray-600 mt-2">پیام شما در سریع‌ترین زمان پیگیری می‌شود.</p>

              <form onSubmit={handleSubmit} className="mt-6 space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="text-xs text-gray-600">نام و نام خانوادگی</label>
                    <input
                      value={form.name}
                      onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
                      className="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#005bbb]/30"
                      placeholder="مثلاً حسین زارعی"
                      required
                    />
                  </div>
                  <div>
                    <label className="text-xs text-gray-600">شماره تماس</label>
                    <input
                      value={form.phone}
                      onChange={(e) => setForm((p) => ({ ...p, phone: e.target.value }))}
                      className="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#005bbb]/30"
                      placeholder="09xxxxxxxxx"
                      inputMode="tel"
                      required
                    />
                  </div>
                </div>

                <div>
                  <label className="text-xs text-gray-600">متن پیام</label>
                  <textarea
                    value={form.message}
                    onChange={(e) => setForm((p) => ({ ...p, message: e.target.value }))}
                    className="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#005bbb]/30 min-h-[140px]"
                    placeholder="درخواست یا سوالتان را بنویسید..."
                    required
                  />
                </div>

                {sent && (
                  <div className="rounded-2xl bg-blue-50 border border-blue-200 px-4 py-3 text-sm text-blue-800">
                    پیام شما ثبت شد. به‌زودی با شما تماس می‌گیریم.
                  </div>
                )}

                {error && (
                  <div className="rounded-2xl bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700">
                    {error}
                  </div>
                )}

                <Button type="submit" disabled={loading} className="w-full rounded-2xl py-6 text-sm font-bold">
                  <span className="inline-flex items-center gap-2">
                    <Send className="w-4 h-4" />
                    {loading ? 'در حال ارسال...' : 'ارسال پیام'}
                  </span>
                </Button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
